<template>
    <div class="timeline__item">
        <h2 class="timeline__item timeline__marker"></h2>
        <h3 class="timeline__year">{{ item.year }}</h3>
        <router-link v-for="(i, index) in item.programs" :key="index" :to="`/programa/${i.code}/${item.year}`">
            <h4 class="timeline__title">{{ i.code }} {{ i.title }}</h4>
        </router-link>
        <!--
        <p class="timeline__blurb">4 Informes técnicos</p>
        <p class="timeline__blurb">5 Estudios de Investigación</p>
        <p class="timeline__blurb">38 Documentos Técnicos</p>  

        <router-link to="/programa/0137/2020">
            <h4 class="timeline__title">0137. Desarrollo de la ciencia, tecnología e innovación tecnológica</h4>
        </router-link>
        <p class="timeline__blurb">4 Informes técnicos</p>
        <p class="timeline__blurb">5 Estudios de Investigación</p>
        <p class="timeline__blurb">38 Documentos Técnicos</p>  

        -->
    </div>
</template>

<script>
export default {
    name: "Year",
    props: {
        item: {
            type: Object,
            default: () => {}
        }
    }
}
</script>
<style scoped>

.timeline__item {
    position: relative;
    margin: 0;
    clear: both;
}
.timeline__item:after,
.timeline__item:before {
    position: absolute;
}
.timeline__item:before {
    right: -10px;
    border-style: solid;
    border-color: var(--color-txt) var(--color-txt) transparent transparent;
    border-width: 10px;
    transform: rotate(45deg);
}
@media screen and (min-width: 700px) {
    .timeline__item {
        width: 44%;
        margin: 1.5rem 0 1.5rem;
        text-align: right;
    }
    .timeline__item:nth-of-type(2n) {
        float: right;
        margin: 1rem 0 1rem 1.5rem;
        border-image: linear-gradient(to right, var(--color-txt) 0%, var(--tertiary) 100%);
        border-image-slice: 1;
        text-align: left;
    }
    .timeline__item:nth-of-type(2n):before {
        right: auto;
        left: -10px;
        border-color: transparent transparent var(--color-txt) var(--color-txt);
    }
}

.timeline__marker {
    text-align: center;
    width: 1.5em;
    height: 1.5em;
    margin: 0;
    background-color: var(--body-color);
    border-radius: 50px;
    display: none;
    border: var(--bd-sections);
    border-width: 2px;
    top: 5px;
}
.timeline__marker:before {
    display: none;
}
.timeline__year {
    font-size: 2em;
    font-weight: 600;
    margin: .5em 0;
    color: var(--color-txt);
}

@media screen and (min-width: 700px) {
    .timeline__marker {
        display: block;
        position: absolute;
    }
    .timeline__item:nth-of-type(2n) .timeline__marker {
        left: -65px;
    }
    .timeline__item:nth-of-type(n) .timeline__marker {
        right: -65px;
    }
    .timeline__year::after {    
        position: absolute;
        right: 0;
    }
    .timeline__item:nth-of-type(2n) .timeline__year::after {    
        left: 0;
    }
    .timeline__year {
        margin: 0 0 1.5em;
    }
}

.timeline__title {
    font-size: 1.3em;
    margin: 1em 0;
}
.timeline__title:hover {
    color: var(--tertiary);
}
.timeline__blurb {
    line-height: 1.5;
    font-size: 1em;
    margin: 0;
}
</style>